export default {
  SET_ORDER: (state, payload) => {
    state.order = payload;
  },
  SET_WAREHOUSE_REPORT: (state, payload) => {
    state.warehouseReport = payload;
  }
}
